import * as React from "react";
import type { SVGProps } from "react";
const SvgStop01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.3999 5.9999C2.3999 4.01168 4.01168 2.3999 5.9999 2.3999H17.9999C19.9881 2.3999 21.5999 4.01168 21.5999 5.9999V17.9999C21.5999 19.9881 19.9881 21.5999 17.9999 21.5999H5.9999C4.01168 21.5999 2.3999 19.9881 2.3999 17.9999V5.9999Z"
    />
  </svg>
);
export default SvgStop01;
